import { render, staticRenderFns } from "./JcdcGradientCardGroup.vue?vue&type=template&id=53f5dd70"
import script from "./JcdcGradientCardGroup.vue?vue&type=script&lang=ts"
export * from "./JcdcGradientCardGroup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports